import { render, staticRenderFns } from "./MessageNotify.vue?vue&type=template&id=00541cf0&scoped=true"
import script from "./MessageNotify.vue?vue&type=script&lang=js"
export * from "./MessageNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00541cf0",
  null
  
)

export default component.exports